/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export const AB_ITEM_SPACER = Symbol("AbItemSpacer");
export let AbItemSpacer;
(function (_AbItemSpacer) {
  const isSpacer = _AbItemSpacer.isSpacer = v => {
    return v === AB_ITEM_SPACER;
  };
  const isNotSpacer = _AbItemSpacer.isNotSpacer = v => {
    return v !== AB_ITEM_SPACER;
  };
})(AbItemSpacer || (AbItemSpacer = {}));
//# sourceMappingURL=AbItemSpacer.js.map
